<template>
  <div>
  
  
  
   <card v-if="createForm" style="margin-bottom:50px">
 		<div style="text-align:right">
				<p-button   type="info" @click="autofill_entity" >Auto-populate - For Online Onboarding Of Client </p-button>
 		</div>
 	</card>
 
        		
        		
        		
        		
        		
  
   <h4 v-if="createForm" slot="header" class="card-title">
      Add A New Company
    </h4>
     <h4 v-else slot="header" class="card-title">
     Update Entity
    </h4>
  
 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Entity Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="entity_name"
                  v-validate="modelValidations.entity_name"
                  :error="getError('entity_name')"
                  v-model="model.entity_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Entity UEN</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="uen"
                  v-validate="modelValidations.uen"
                  :error="getError('uen')"
                  v-model="model.uen">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Registered Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="registered_address"
                  v-validate="modelValidations.registered_address"
                  :error="getError('registered_address')"
                  v-model="model.registered_address">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	 <div class="row">
      <label class="col-sm-2 col-form-label">Company Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Company Type"
                             v-model="model.company_type">
                    <el-option v-for="option in selects.coy_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>



    <div class="row">
      <label class="col-sm-2 col-form-label">Company Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select The Company Status"
                             v-model="model.company_status">
                    <el-option v-for="option in selects.coy_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Is Company Listed?</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Is Your Company Listed?"
                             v-model="model.is_listed">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
	</card>
	
	
	<card class="form-horizontal">
	<div class="row">
      <label class="col-sm-2 col-form-label">Financial Year End</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.date_fye" type="date" placeholder="Select A Date"
              	name ="date_fye"
              	:error="getError('date_fye')"
              	v-bind:class="{ field_error_cs: errors.has('date_fye') }"
                v-validate="modelValidations.date_fye" 
              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('date_fye')"> FYE date is required.</span>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Incorporation Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                name="date_incorp"
              	v-model="model.date_incorp" type="date" placeholder="Select A Date"
                v-validate="modelValidations.date_incorp" 
                :error="getError('date_incorp')"
              	v-bind:class="{ field_error_cs: errors.has('date_incorp') }"              
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
       <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('date_incorp')">Incorporation date is required.</span>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Auditor</label>
      <div class="col-sm-7">
       	   <textarea 
        		 cols="45" rows="10"
                  name="auditor"
                  v-model="model.auditor">
       	    </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    </card>
	    
    <card class="form-horizontal">
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Sign-up Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                name="date_signup"
              	v-model="model.date_signup" type="date" placeholder="Select A Date"
             	v-validate="modelValidations.date_signup" 
             	 :error="getError('date_signup')"
              	v-bind:class="{ field_error_cs: errors.has('date_signup') }"      
                              >
                              
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('date_incorp')">Sign-up date is required.</span>
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       	   <textarea 
        		 cols="45" rows="10"
                  name="new_reso_item"
                  v-model="model.notes">
       	    </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
   
	
	
	</card>
	    
    <card class="form-horizontal">
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Principal Activity (I) Code</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="principal_activity_1_code"
                  v-model="model.principal_activity_1_code"
                  :error="getError('principal_activity_1_code')"
                  v-validate="modelValidations.principal_activity_1_code" 
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Principal Activity (I) Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="principal_activity_1_title"
                  :error="getError('principal_activity_1_title')"
                  v-model="model.principal_activity_1_title"
                   v-validate="modelValidations.principal_activity_1_title" 
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Activity (I) Description <span style="">(Business Nature)</span></label>
      <div class="col-sm-7">
      <div style="min-height:7px;"></div>
        <fg-input type="text"
                  name="principal_activity_1_desc"
                  v-model="model.principal_activity_1_desc"
                   :error="getError('principal_activity_1_desc')"
                   v-validate="modelValidations.principal_activity_1_desc" 
                
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Principal Activity (II) Code</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="principal_activity_2_code"
                  v-model="model.principal_activity_2_code">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Principal Activity (II) Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="principal_activity_2_title"
                  v-model="model.principal_activity_2_title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Activity (II) Description</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="principal_activity_2_desc"
                  v-model="model.principal_activity_2_desc">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    </card>    
    <card class="form-horizontal">
    
     <div class="row">
      <label class="col-sm-2 col-form-label">AGM Exemption</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Is Your Company Exempted From Holding AGM?"
                             v-model="model.is_agm_exempted">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ECI Exemption</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Is Your Company Exempted From Filing ECI?"
                             v-model="model.is_eci_exempted">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">GST Registered</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Is Your GST Registered?"
                             v-model="model.is_gst">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    



  

  </card>
          
          
   <div>
      <h4 v-if="createForm" class="title">Add Point Of Contact</h4>
      <h4 v-else class="title">Change Point Of Contact</h4>
   </div> 
         
   <card>     
      <div>Search Using Govt ID Number</div>
				   <fg-input type="text"
                  		name="search_person_id_num"
                 	    v-model="search_person_id_num"
                 	    style="max-width:500px"
                 	    >
        			</fg-input>


			   <p-button  outline type="default" @click.prevent="searchPerson()">Search People</p-button>
		<div v-if="poc_person_found" style="margin-top:50px;margin-bottom:50px;">
		 
		  <h5 >Point Of Contact Is</h5>
		<strong> Name: </strong>  {{poc_person.first_name}} {{poc_person.last_name}} 
		 <br/>
		<strong> ID Number: </strong>  {{poc_person.gov_id}}
		 <br/>
		<strong> Contact Number: </strong> {{poc_person.contact_num}}
		  <br/>
		<strong> Email: </strong> {{poc_person.email}}
		
		</div>	         
    </card>    
   
   
   
   <h4 style="font-weight:bold;">Actions</h4>
	<card>
		  <div class="text-center" style="">
      		<p-button v-if="createForm"  type="info" @click.prevent="validate">Create New Company</p-button>
     		<p-button v-else  type="info" @click.prevent="editEntity">Update Entity</p-button>
    	</div>
	
	</card>
   
   
    


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	if(this.eid!=0){
			let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.id;
			 ApiService.get(uri).then(response => {
				this.createForm = false
				this.model = response.data.entity;
				if(response.data.point_of_contact){
					this.poc_person = response.data.point_of_contact;
					this.poc_person_found = true;
				}
			
			})
      	}
      	
      	
      
    },
    
     
    data () {
      return {
    	eid: this.$route.params.id,
    	createForm: true,
    	search_person_id_num: '',
    	poc_person:[],
    	poc_person_found: false,
        model: {
          entity_name: '',
          uen: '',
          company_status: 1,
          company_type: 1,
          date_fye: '',
          date_incorp: '',
          registered_address: '',
          is_agm_exempted: 2,
          is_listed: 2,
          is_gst: 2,
          is_eci_exempted: 2,
          poc_id: '',

        },
        modelValidations: {
          entity_name: {
            required: true
          },
          uen: {
            required: true,
          },
          date_fye: {
            required: true,
          },
          date_incorp: {
          	required: true,
          },
           date_signup: {
          	required: true,
          },
          company_type: {
            required: true,
          },
          company_status: {
            required: true,
          },
          principal_activity_1_code: {
            required: false,
          },
          principal_activity_1_title: {
            required: false,
          },
          principal_activity_1_desc: {
            //required: true,
          },
          registered_address:{
          	required: true,
          }
        },
        
        selects: {
          coy_status: this.$entity_status,
		  coy_type: this.$entity_type,
		  yesno: [
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ],
        },
      }
    },
    methods:{
       autofill_entity(){
    		this.model.date_fye = new Date();
    		this.model.date_incorp = new Date();
    		this.model.date_signup = new Date();
    		
    		this.model.registered_address = "Singapore";
    		
    		this.model.company_status = 5;
    		
    		var current = new Date();
    		var t_uen = current.getFullYear()+""+current.getMonth()+ ""+current.getDate();
    		t_uen = t_uen + current.getSeconds()+""+current.getMinutes()+""+current.getHours();
    		t_uen = t_uen + "U"+ Math.floor((Math.random() * 100));
    		
    		this.model.uen = "E"+t_uen;
    		
    		swal({
						  title: 'Fields Have Been Auto-populated',
						  text: 'Please create a client portal account and grant access to the account for client to proceed with onboarding.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						})
						
						
       },
       searchPerson(){
       		let search_term = "NONE";

			search_term = this.search_person_id_num
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;

       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){

							this.poc_person = response.data.person;
      						this.model.poc_id = response.data.person.id;
      						this.poc_person_found = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Person not found. Please add this person to the database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })

    	},//end search person
      displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
       
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities';
      		ApiService.post(uri, this.model).then(response => {
      		
      				if(!response.data.entity){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				let e =  response.data.entity;
         				this.$router.push( '/view-entity/'+e.id)
         			}
         			
      				
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editEntity() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/edit/'+this.eid;
      		ApiService.post(uri, this.model).then(response => {
      	
         			if(!response.data.entity){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				let e =  response.data.entity;
         				this.$router.push( '/view-entity/'+e.id)
         			}
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


